export const JT_REGULAR_PRICELIST_TYPE_NAME = 'jt regular';
export const SOFTSIM_TYPE = 'uicc_softsim';
export const ESIM_TYPE = 'euicc_smdpp';

export const SIM_TYPES = {
  UICC_CHIP: 'uicc_chip',
  UICC_SOFTSIM: SOFTSIM_TYPE,
  UICC_CARD: 'uicc_card',
  EUICC_CARD: 'euicc_card',
  EUICC_CHIP: 'euicc_chip',
  EUICC_SMDPP: ESIM_TYPE,
} as const;

export type SimType = (typeof SIM_TYPES)[keyof typeof SIM_TYPES];
